import React from "react";
import { useTable, useSortBy } from "react-table";

interface DataTableProps {
  data: any[];
  columns: any[];
}

const DataTable: React.FC<DataTableProps> = ({ data, columns }) => {
  // Use the React Table hook in a proper React component
  const tableInstance = useTable(
    {
      columns,
      data,
    },
    useSortBy
  );

  const { getTableProps, getTableBodyProps, headerGroups, rows, prepareRow } =
    tableInstance;

  return (
    <div className="overflow-hidden rounded-lg border border-purple-100/30">
      <table {...getTableProps()} className="w-full border-collapse">
        <thead>
          {headerGroups.map((headerGroup, index) => (
            <tr
              {...headerGroup.getHeaderGroupProps()}
              key={`${headerGroup.id}-${index}`}
            >
              {headerGroup.headers.map((column: any) => {
                const renderSortIndicator = () => {
                  if (!column.isSorted) return null;
                  return column.isSortedDesc ? " 🔽" : " 🔼";
                };

                return (
                  <th
                    key={column.id}
                    {...column.getHeaderProps(column.getSortByToggleProps())}
                    className="cursor-pointer border-b border-purple-100/30 p-3 text-left text-sm font-medium text-purple-900"
                  >
                    {column.render("Header")}
                    <span>{renderSortIndicator()}</span>
                  </th>
                );
              })}
            </tr>
          ))}
        </thead>
        <tbody
          {...getTableBodyProps()}
          className="divide-y divide-purple-100/30"
        >
          {rows.map((row) => {
            prepareRow(row);
            return (
              <tr {...row.getRowProps()} key={row.id}>
                {row.cells.map((cell) => (
                  <td
                    {...cell.getCellProps()}
                    className="border-b border-purple-100/30 p-3 text-sm text-gray-700"
                  >
                    {cell.render("Cell")}
                  </td>
                ))}
              </tr>
            );
          })}
        </tbody>
      </table>
    </div>
  );
};

export default DataTable;
